import { useScreenSize } from '@/hooks';
import type { SVGProps } from 'react';

type Props = Omit<SVGProps<SVGSVGElement>, 'width' | 'height'> & {
    width?: number;
    height?: number;
    fill?: string;
};

export const TurnLeftIcon = ({ width = 40, height = 40, fill = 'currentColor', ...props }: Props) => {
    const { scaleHeightPixel, scaleWidthPixel } = useScreenSize();

    return (
        <svg width={scaleWidthPixel(width)} height={scaleHeightPixel(height)} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M24 26V18.2342C24 17.5526 23.3416 17 22.5293 17L13 17.0001" stroke={fill} stroke-width="2" stroke-linecap="round" />
            <path d="M17 13L13 17L17 21" stroke={fill} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    );
};
